import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {routing} from './document-management-system.routing';

@NgModule({
  imports: [
    CommonModule,
      routing
  ],
  declarations: []
})
export class DocumentManagementSystemModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/document-management-system/document-management-system.module.ts